import { render, staticRenderFns } from "./OtpAuthSetting.vue?vue&type=template&id=73d830b0&"
import script from "./OtpAuthSetting.vue?vue&type=script&lang=ts&"
export * from "./OtpAuthSetting.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports